/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { AdminSaleOffer } from 'src/core/models'
import { SaleOfferActionsColumn } from 'src/components'
import styles from './AdminSaleOfferActionsColumn.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { convertSaleOfferIntoUserSaleOffer } from 'src/core/helpers'
import {
  acceptSaleOffferSelector,
  rejectSaleOffferSelector,
  updateAdminSaleOfferStatusOnList
} from 'src/features'

const AdminSaleOfferActionsColumn: React.FC< { offer: AdminSaleOffer }> = ({ offer }) => {
  const dispatch = useAppDispatch()
  const convertedOffer = convertSaleOfferIntoUserSaleOffer(offer)

  const {
    success: successAccept,
    currenctOfferId: offerIdAccept
  } = useAppSelector(acceptSaleOffferSelector)

  const {
    success: successReject,
    currenctOfferId: offerIdReject
  } = useAppSelector(rejectSaleOffferSelector)

  useEffect(() => {
    if (offer.id === offerIdAccept && successAccept) {
      dispatch(updateAdminSaleOfferStatusOnList({ offerId: offer.id, status: 'accepted' }))
    }
  }, [successAccept, offerIdAccept])

  useEffect(() => {
    if (offer.id === offerIdReject && successReject) {
      dispatch(updateAdminSaleOfferStatusOnList({ offerId: offer.id, status: 'rejected' }))
    }
  }, [successReject, offerIdReject])

  return <div className={styles.content}>
    <SaleOfferActionsColumn offer={convertedOffer} />
  </div>
}

export default AdminSaleOfferActionsColumn
